import React from "react";

/**
 * Displays a table of files with selection capability
 *
 * @param {Object} props
 * @param {Array} props.files - Array of file objects
 * @param {Array} props.selectedFiles - Array of selected file IDs
 * @param {Function} props.onSelectFile - Function to call when a file is selected
 * @param {Function} props.onSelectAll - Function to call when all files are selected/deselected
 * @returns {JSX.Element}
 */
const FileTable = ({
  files = [],
  selectedFiles = [],
  onSelectFile,
  onSelectAll,
}) => {
  if (files.length === 0) {
    return (
      <div className="text-center py-12 bg-gray-50 rounded-lg">
        <p className="text-gray-600">
          No files available. Drop files above to get started.
        </p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th scope="col" className="py-3 px-4 w-12">
              <input
                type="checkbox"
                className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                checked={
                  selectedFiles.length === files.length && files.length > 0
                }
                onChange={() =>
                  onSelectAll(
                    selectedFiles.length === files.length
                      ? []
                      : files.map((file) => file.id)
                  )
                }
              />
            </th>
            <th
              scope="col"
              className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Name
            </th>
            <th
              scope="col"
              className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Type
            </th>
            <th
              scope="col"
              className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Created
            </th>
            <th
              scope="col"
              className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Updated
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {files.map((file) => (
            <tr key={file.id} className="hover:bg-gray-50">
              <td className="py-4 px-4">
                <input
                  type="checkbox"
                  className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                  checked={selectedFiles.includes(file.id)}
                  onChange={() => onSelectFile(file.id)}
                />
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                {file.name}
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                {file.type || "Unknown"}
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                {file._created_at
                  ? new Date(file._created_at).toLocaleDateString()
                  : "N/A"}
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                {file._updated_at
                  ? new Date(file._updated_at).toLocaleDateString()
                  : "N/A"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FileTable;
